import React from 'react';
import type { RunConfig } from '../../index';

interface Props {
  config: RunConfig;
  title?: string;
}

const RunConfigSummary: React.FC<Props> = ({
  config,
  title = '运行配置',
}) => {
  const variables = config.variables.filter(item => item.key.trim());

  return (
    <div className="rounded-xl bg-[#f9fafb] p-4">
      <h4 className="mb-3 text-sm font-bold text-[#111827]">{title}</h4>
      {config.orgName && <SummaryRow label="组织" value={config.orgName} />}
      {config.scenarioName && (
        <SummaryRow label="过程本体" value={config.scenarioName} />
      )}
      {config.objectOntologyName && (
        <SummaryRow label="对象本体" value={config.objectOntologyName} />
      )}
      {config.knowledgeBaseName && (
        <SummaryRow label="知识库" value={config.knowledgeBaseName} />
      )}
      {variables.length > 0 && (
        <div>
          <span className="text-xs font-medium text-[#6b7280]">变量：</span>
          {variables.map((item, index) => (
            <p key={index} className="mt-0.5 mb-0 text-xs text-[#111827]">
              {item.key}：{item.value ?? ''}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

const SummaryRow: React.FC<{ label: string; value: React.ReactNode }> = ({
  label,
  value,
}) => {
  return (
    <div className="mb-3 last:mb-0">
      <span className="text-xs font-medium text-[#9ca3af]">{label}：</span>
      <p className="mt-1 mb-0 text-sm leading-6 text-[#374151]">{value}</p>
    </div>
  );
};

export default RunConfigSummary;
